import {h, Fragment} from "preact"
import { useProductFilters } from "@nosto/preact"
import { toggleFacets, lumberFinishFilters } from "../config"

export default function SelectedFilters() {
    const { filters, removeAll } = useProductFilters()

    const formatPriceRange = (priceRange) => {
        if (!priceRange || typeof priceRange !== 'string') return priceRange;
        
        const parts = priceRange.split(' - ');
        if (parts.length !== 2) return priceRange;
        
        const [min, max] = parts.map(price => {
            const num = parseInt(price.trim());
            return isNaN(num) ? price : num.toLocaleString();
        });
        
        return `$${min} - $${max}`;
    };

    return (
        filters.length > 0 && (
            <div class="flex overflow-hidden mb-sm">
                <div class="relative overflow-auto scroll-area flex items-center w-full pl-pagemargin py-0 gap-xs lg:flex-wrap [&amp;:not(:empty)]:mt-sm lg:[&amp;:not(:empty)]:mt-0">
                    <button
                        type="button"
                        aria-label="Clear all filters"
                        class="body-14 underline text-t-foreground whitespace-nowrap shrink-0"
                        onClick={removeAll}
                    >
                        Clear Filters
                    </button>
                    {filters.map(filter => {
                        const isLumberFinish = filter.name === "Lumber Finish";
                        const isPriceRange = filter.name === "Price";
                        const isToggle = toggleFacets.find(f => f.facetName.toLowerCase() === filter.name.toLowerCase());
                        
                        // Parse JSON-encoded values to get the actual string value
                        let parsedValue = filter.value;
                        try {
                            const parsed = JSON.parse(filter.value);
                            parsedValue = Array.isArray(parsed) ? parsed[0] : parsed;
                        } catch {
                            // If parsing fails, use the original value
                            parsedValue = filter.value;
                        }
                        
                        const valueName = isToggle
                            ? filter.name 
                            : isPriceRange
                                ? formatPriceRange(parsedValue)
                            : isLumberFinish 
                                ? lumberFinishFilters[parsedValue] 
                                : parsedValue;

                        const iconUrl = document.querySelector('meta[data-svg-sprite-path]').dataset.svgSpritePath + '#icon-close' ?? '#icon-close';

                        return (
                            <button
                                key={`${filter.name}: ${filter.value}`}
                                type="button"
                                aria-label={`Remove filter: ${valueName}`}
                                data-filter-type={filter.name}
                                data-filter-value={valueName}
                                onClick={() => filter.remove()}
                                class="ns-selected-filter flex justify-center p-xs bg-t-background-secondary text-t-foreground whitespace-nowrap shrink-0"
                            >
                                <span class="capitalize inline-flex gap-xs items-center caption">
                                    {valueName}
                                    <svg class="block w-full h-full" aria-label="icon-close" role="presentation" focusable="false">
                                        <use crossorigin="anonymous" href={iconUrl}></use>
                                    </svg>
                                </span>
                            </button>
                        )
                    })}
                </div>
            </div>
        )
    )
}
